import React from 'react';

import {
  Section,
  Stack,
  Button,
  ToggleButtonGroup,
  ToggleButton,
} from '@gogame/components';
import { withForm, FormField, SubmitButton } from '@gogame/form';

import {
  APP_ID,
  UM_ID,
  INVITER,
  INVITED,
  AD_ID,
} from 'scenes/PlayersActivities/PlayersInformation/constants';
import { addRequestForm } from 'scenes/PlayersActivities/PlayersInformation/schemas/addRequestForm';
import { loadApplications } from 'scenes/PlayersActivities/PlayersInformation/sources/fields';

import { Container, Content, Footer } from '../Container';

const ReferralRequestForm = withForm({
  enableReinitialize: true,
  validationSchema: addRequestForm,
})(({ values, setValues, resetForm }) => {
  const handleClear = () => {
    resetForm({});
  };

  const handleChangeRoleType = (_, value) => {
    setValues({
      ...values,
      [INVITER]: INVITER === value,
      [INVITED]: INVITED === value,
    });
  };

  return (
    <Container>
      <Content>
        <Section title={'Account'}>
          <Stack spacing={3}>
            <FormField.Select
              name={APP_ID}
              label={'Application'}
              source={loadApplications}
              required={true}
              padding={0}
            />
            <FormField.TextField name={UM_ID} label={'UID'} padding={0} />
            <FormField.TextField
              label={'Advertising ID'}
              name={AD_ID}
              padding={0}
            />
            <ToggleButtonGroup
              size={'small'}
              color={'primary'}
              exclusive={true}
              onChange={handleChangeRoleType}
              value={values[INVITER] ? INVITER : INVITED}
            >
              <ToggleButton value={INVITER}>Inviter</ToggleButton>
              <ToggleButton value={INVITED}>Invited</ToggleButton>
            </ToggleButtonGroup>
          </Stack>
        </Section>
      </Content>
      <Footer justifyContent={'space-between'}>
        <Button onClick={handleClear} role={'button'}>
          Clear
        </Button>
        <SubmitButton
          title={'Apply'}
          disabled={!(values[APP_ID] && (values[UM_ID] || values[AD_ID]))}
        />
      </Footer>
    </Container>
  );
});

export default ReferralRequestForm;
